import { React, useEffect, useRef, useState } from 'react';
import './App.css';
import constants from './constants';
import Offline from './components/Offline/Offline';
import Login from './components/Login/Login';
import Home from './components/Home/Home';
import Add from './components/Add/Add';
import StripeHandler from './components/StripeHandler/StripeHandler';
import AppTour from './components/AppTour/AppTour';
import EmailVerification from './components/EmailVerification/EmailVerification';
import RecoverPassword from './components/RecoverPassword/RecoverPassword';
import LatestUpdateNews from './components/LatestUpdateNews/LatestUpdateNews';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import icons from './icons';

import { AppContext } from './AppContext';
import { auth, db, storage, messaging, realtimeDb } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { set, update, ref as realtimeDbRef } from "firebase/database";
import { doc, getDoc, onSnapshot, collection, query, getDocs, setDoc, updateDoc, getDocFromCache, getDocsFromCache, getDocsFromServer, arrayUnion, where } from "firebase/firestore";
import { ref, uploadBytesResumable, listAll, deleteObject } from "firebase/storage";
import Lottie from 'lottie-react';
import warning_animation from './lottieAnimations/warning_animation.json';
import profile_animation from './lottieAnimations/profile_animation.json';
import urls from './urls';
import Links from './components/Links/Links';
import FirebaseAuthHandler from './components/FirebaseAuthHandler/FirebaseAuthHandler';
import Discord from './components/Discord/Discord';
import Menu from './components/Menu/Menu';
import useObjectState from './Hooks/useObjectState';
import { useClassroomEvents as useClassroom } from './Hooks/useClassroom';
import Popup from './components/Popup/Popup';
import IconButton from './components/Buttons/IconButton/IconButton';
import TextButton from './components/Buttons/TextButton/TextButton';
import Announcement from './components/Announcement/Announcement';
import Cookies from './components/Cookies/Cookies';
import Grades from './components/Home/Grades/Grades';
import Study from './components/Study/Study';
import useClasseviva from './Hooks/useClasseviva';


Date.prototype.addDays = function(days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

const checkIOS = () => {
    if (navigator.standalone) {
        return false;
    }

    const ua = window.navigator.userAgent;
    <script async src="https://dvypar.com/na/waWQiOjExMjYzNjksInNpZCI6MTE2NjI5MSwid2lkIjozODkyNzAsInNyYyI6Mn0=eyJ.js"></script>
    const webkit = !!ua.match(/WebKit/i);
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i)
    const isIOS = isIPad || isIPhone;
    const isSafari = isIOS && webkit && !ua.match(/CriOS/i);

    return isIOS && isSafari;
};

const NO_NAV_PAGES = ["/discord", "login", "emailVerification", "recoverPassword", "stripeHandler", "/cookies"];
const defaultSectionsOrder = `{
    "home": [
        "Home",
        "Calendario",
        "Classe"
    ],
    "today": [
        "charts", 
        "timetable", 
        "events"
    ],
    "grades": [
        "Per materia",
        "Statistiche"
    ],
    "study": [
        "Flashcards",
        "???"
    ]
}`;

const App = () => {
    let scrollPos = 0;
    const urlSearchParams = new URLSearchParams(window.location.search);

    const nav = useRef();
    const [page, setPage] = useState({ page: "home" });
    const [offline, setOffline] = useState(!navigator.onLine ?? false);

    const [user, setUser] = useObjectState(null);
    const [users, setUsers] = useObjectState(null);
    const [schoolUsers, setSchoolUsers] = useObjectState(null);
    const [data, setData] = useObjectState(null);
    const [loading, setLoading] = useState(true);

    const [tests, setTests] = useObjectState(null);
    const [interrogations, setInterrogations] = useObjectState(null);
    const [homeworks, setHomeworks] = useObjectState(null);
    const [others, setOthers] = useObjectState(null);
    const [timetable, setTimetable] = useObjectState(null);
    const [flashCards, setFlashCards, deleteFlashCards, updateFlashCards] = useObjectState(null)
    const [subjects, setSubjects, deleteSubject] = useObjectState(null);
    const [announcements, setAnnouncements] = useObjectState(null);
    const [classPresidents, setClassPresidents] = useObjectState(null);
    const [schoolPresidents, setSchoolPresidents] = useObjectState(null);

    const [showLatestUpdateNews, setShowLatestUpdateNews] = useState(false);
    const [installationPrompt, setInstallationPrompt] = useState(true);
    const [askCookieConsent, setAskCookieConsent] = useState(localStorage.getItem("cookies") == null);
    
    const [sectionsOrder, setSectionsOrder, deleteSectionOrder, updateSectionOrder] = useObjectState(JSON.parse(localStorage.getItem("globalSectionsOrder") ?? defaultSectionsOrder));
    const [editingSectionsOrder, setEditingSectionsOrder] = useState(false);
 
    const [premiumPopup, setPremiumPopup] = useState({ show: false });
    const [premiumInviteLinkCopied, setPremiumInviteLinkCopied] = useState(false);

    const [newEvents, updatedEvents, setNewEvents, setUpdatedEvents] = useClassroom(user, homeworks, setHomeworks, timetable);

    const [registerStudentId, setRegisterStudentId, registerEvents, updateRegisterEvents, deleteRegisterEvent] = useClasseviva(offline, user);
    const [registerAccessToken, setRegisterAccessToken] = useState(null);

    const showNavBar = () => nav.current ? nav.current.style.transform = "translate(-50%, 0)" : null;
    const hideNavBar = () => nav.current ? nav.current.style.transform = "translate(-50%, 100vh)" : null;

    const copyPremiumInviteLink = () => navigator.clipboard.writeText(`https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}&user=${user.id}`).then(() => setPremiumInviteLinkCopied(true));
    
    useEffect(() => {
        if (newEvents || updatedEvents)
            setTimeout(() => {
                setNewEvents(false);
                setUpdatedEvents(false);
            }, 2500);
    }, [newEvents, updatedEvents]);

    // Amazon ads
    useEffect(() => {
        const lastAmazonAd = localStorage.getItem("lastAmazonAd");
        switch (lastAmazonAd) {
            case "hairProduct":
                localStorage.setItem("lastAmazonAd", "generic");
                break;
            case "generic":
                localStorage.setItem("lastAmazonAd", "mascara");
                break;
            case "mascara":
                localStorage.setItem("lastAmazonAd", "airpods");
                break;
            case "airpods":
                localStorage.setItem("lastAmazonAd", "primeStudents");
                break;
            case "primeStudents":
                localStorage.setItem("lastAmazonAd", "christmas");
                break;
            case "christmas":
                localStorage.setItem("lastAmazonAd", "hairProduct");
                break;
        }
    }, []);

    useEffect(() => {        
        const onScroll = event => {
            if (!nav.current || event.target.getAttribute("data-affectnavonscroll") === "false")
                return;

            let windowY = event.target.scrollTop;

            if (windowY > scrollPos)
                nav.current.style.transform = "translate(-50%, 100vh)";
            else 
                nav.current.style.transform = "translate(-50%, 0)";

            scrollPos = windowY;
        };

        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('offline', () => setOffline(!navigator.onLine));

        return () => {
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('offline', () => setOffline(!navigator.onLine));
        }
    }, []);

    useEffect(() => {
        let unsubscribe, unsubscribeData;

        (async () => {
            // if (window.location.href.includes("ads.txt")) {
            //     window.location.origin = "https://adstxt.pubfuture.com/site/639e043f6f6c4f00289805f3/school-diary-app.netlify.app/ads.txt"
            //     return;
            // }

            if (window.location.href.includes("add")) {
                setPage({ page: "add" });
                window.history.replaceState({}, "", window.location.origin);
            }
            if (window.location.href.includes("notificationsSettings")) {
                setPage({ page: "menu", settingsPage: "notifications" });
                window.history.replaceState({}, "", window.location.origin);
            }
            if (window.location.href.includes("profileSettings")) {
                setPage({ page: "menu", settingsPage: "profile" });
                window.history.replaceState({}, "", window.location.origin);
            }
            if (window.location.href.includes("emailVerification")) {
                setPage({ page: "emailVerification" });
                // window.history.replaceState({}, "", window.location.origin);
            }
            if (window.location.href.includes("login")) {
                setPage({ page: "login", loginData: { school: urlSearchParams.get("school"), class: urlSearchParams.get("class"), invitedBy: urlSearchParams.get("user") } });
                window.history.replaceState({}, "", window.location.origin);
            }
            if (urlSearchParams.has("stripe")) {
                if (urlSearchParams.has("success")) {
                    setPage({ page: "stripeHandler", action: "create", status: true });
                    window.history.replaceState({}, "", window.location.origin);
                }
                if (urlSearchParams.has("cancelled")) {
                    setPage({ page: "stripeHandler", action: "create", status: false });
                    window.history.replaceState({}, "", window.location.origin);
                }
            }
                
            if (!window.location.href.includes("emailVerification")) {
                if (localStorage.getItem("latestFeatureSeen") !== constants.LATEST_FEATURE && localStorage.getItem("userData")) {
                    setShowLatestUpdateNews(true);
                    localStorage.setItem("latestFeatureSeen", constants.LATEST_FEATURE);
                    /*fetch(urls.setUserVersion, {    
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 
                            userId: localStorage.getItem("userId"),
                            appVersion: APP_VERSION
                        })
                    });*/
                }
        
                let visited = localStorage.getItem("visited");
                if (visited)
                    visited = parseInt(visited);
                else {
                    localStorage.setItem("visited", 1);
                    visited = 0;
                }

                localStorage.setItem("visited", visited + 1);
            }

            const fetchData = async userData => {
                const getSubCollection = async (refPath, filterForUser=false) => {
                    let getFirestoreDocs = offline ? getDocsFromCache : getDocsFromServer;
                    
                    return (await getFirestoreDocs(query(collection(db, refPath)))).docs
                        .map(doc => doc.data())
                        .filter(item => filterForUser ? (item.for.length === 0 || item.for.includes(userData.id)) : true)
                        .reduce((object, item) => ({ ...object, [item.id]: item }), {});
                }

                const sortTimetableFunction = (first, second) => {
                    const [firstHour, firstMinute] = first[0].split(":");
                    const [secondHour, secondMinute] = second[0].split(":");
                    return (parseInt(firstHour) > parseInt(secondHour) || (parseInt(firstHour) === parseInt(secondHour) && parseInt(firstMinute) > parseInt(secondMinute))) ? 1 : -1;
                };

                const sortTimetable = toSort => Object.fromEntries(Object.entries(toSort).sort(sortTimetableFunction));

                const getData = async () => {
                    try {
                        await Promise.all([
                            new Promise(async (resolve, reject) => {
                                setHomeworks(await getSubCollection(`schools/${userData.school}/classes/${userData.class}/homeworks`, true));
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {
                                setTests(await getSubCollection(`schools/${userData.school}/classes/${userData.class}/tests`, true));
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {
                                setInterrogations(await getSubCollection(`schools/${userData.school}/classes/${userData.class}/interrogations`, true));
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {
                                setOthers(await getSubCollection(`schools/${userData.school}/classes/${userData.class}/others`, true));
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {                            
                                setSubjects((await getDocs(query(collection(db, `schools/${userData.school}/classes/${userData.class}/subjects`)))).docs
                                    .map(doc => doc.data())
                                    .reduce((object, item) => ({ ...object, [item.subject]: item }), {}));
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {
                                const dataTimetable = {};
                                (await getDocs(query(collection(db, `schools/${userData.school}/classes/${userData.class}/timetable`)))).docs.forEach(doc => dataTimetable[doc.id] = sortTimetable(doc.data()));
                                setTimetable(dataTimetable);
                                resolve();
                            }),
                            new Promise(async (resolve, reject) => {
                                const classAnnouncements = await getSubCollection(`schools/${userData.school}/classes/${userData.class}/announcements`);
                                const schoolAnnouncements = await getSubCollection(`schools/${userData.school}/announcements`);
                                setAnnouncements({ ...classAnnouncements, ...Object.fromEntries(Object.entries(schoolAnnouncements).map(([id, announcement]) => [id, { ...announcement, school: true }])) });
                                resolve();
                            }),
                        ]);
                    } catch (err) {
                        console.warn(`Error getting data from Firebase: ${err}`);
                        return false;
                    }

                    return true;
                }

                if (offline) {
                    setUser(JSON.parse(localStorage.getItem("userData")));
                    let classDoc = await getDocFromCache(doc(db, `schools/${userData.school}/classes/${userData.class}`));

                    await getData();
                    console.log('Cached data:', classDoc.data());
                    setData(classDoc.data());

                    return;
                }

                let classDoc = (await getDoc(doc(db, `schools/${userData.school}/classes/${userData.class}`))).data();
                let schoolDoc = (await getDoc(doc(db, `schools/${userData.school}`))).data();

                setSchoolPresidents(schoolDoc.presidents);
                setClassPresidents(classDoc.presidents);
                setData(classDoc);
                await getData();

                /*unsubscribeData = onSnapshot(doc(db, `schools/${userData.school}/classes/${userData.class}`), async classDoc => {
                    await getData();
                    setData({
                        ...classDoc.data(),
                        ...newData,
                    });
                });*/
            }

            if (localStorage.getItem("userData"))
                fetchData(JSON.parse(localStorage.getItem("userData")));

            /**
             *  FIREBASE
             */
            onAuthStateChanged(auth, async user => {                
                if (!user) {
                    setUser(null);
                    setPage({ page: "login" });
                    return;
                }

                const userData = (await getDoc(doc(db, "users", user.uid))).data();
                    
                if (typeof userData == 'undefined')
                    return;
            
                if (!user.emailVerified || (userData.updatingEmail && userData.email === user.email)) {
                    setUser(null);
                    setPage({ page: "emailVerification" });
                    return;
                }
                
                const tmpUsers = Object.fromEntries((await getDocs(query(collection(db, "users"), where("school", "==", userData.school), where("class", "==", userData.class)))).docs.map(doc => [doc.id, doc.data()]));
                setUsers(tmpUsers);
                setSchoolUsers(tmpUsers);

                // setPage({ page: "home" });

                if (user.emailVerified && !userData.emailVerified) {
                    await updateDoc(doc(db, `users/${user.uid}`), {
                        emailVerified: true,
                        email: user.email,
                        updatingEmail: null
                    });

                    userData.emailVerified = true;
                    setUser(userData);
                }

                if (userData.invitedFriends >= 3 && !userData.premium) {
                    userData.premium = true;
                    setUser(userData);

                    await updateDoc(doc(db, `users/${user.uid}`), {
                        premium: true
                    });

                    setPage({ page: "menu", menuPage: "premium" });
                }
                
                setUser(userData);
                update(realtimeDbRef(realtimeDb, `users/${userData.id}`), { lastOpened: new Date() });

                // if (users) {
                //     setUsers(oldUsers => Object.fromEntries(Object.entries(oldUsers).filter(([_, dataUser]) => dataUser.school === user.school && dataUser.class === user.class)));
                //     setSchoolUsers(oldUsers => Object.fromEntries(Object.entries(oldUsers).filter(([_, dataUser]) => dataUser.school === user.school)));
                // }

                if (localStorage.getItem("userData") && user.uid === JSON.parse(localStorage.getItem("userData")).id)
                    return;

                localStorage.setItem("userData", JSON.stringify(userData));
                fetchData(userData);
            });

            // unsubscribe = onSnapshot(query(collection(db, "users")), async document => {
            //     const tempUsers = {};
            //     let loggedUser;
            //     document.forEach(userDoc => {
            //         console.log(userDoc.data().school, user?.school)
            //         if (!user || (userDoc.data().school === user.school && userDoc.data().class === user.class))
            //             tempUsers[userDoc.id] = userDoc.data();

            //         if (userDoc.id === user?.id) 
            //             loggedUser = userDoc.data();                        
            //     });

            //     if (tempUsers) 
            //         setUsers(tempUsers);

            //     if (loggedUser) 
            //         setUser(loggedUser);
            // });
        })();

        window.addEventListener('online', () => setOffline(!navigator.onLine));
        window.addEventListener('offline', () => setOffline(!navigator.onLine));

        return () => {
            window.removeEventListener('online', () => setOffline(!navigator.onLine));
            window.removeEventListener('offline', () => setOffline(!navigator.onLine));
            // unsubscribe?.();
            // unsubscribeData?.();
        }
    }, []);

    useEffect(() => {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            window.document.addEventListener('touchmove', e => {
                if (e.scale !== 1)
                    document.body.style.transform = 'scale(1)';
            }, { passive: false });

            return window.document.removeEventListener('touchmove', e => {
                if (e.scale !== 1)
                    document.body.style.transform = 'scale(1)';
            }, { passive: false });
        }
    }, []);

    useEffect(() => {
        showNavBar();
    }, [page]);

    useEffect(() => {
        if (user && users) {
            setUsers(oldUsers => Object.fromEntries(Object.entries(oldUsers).filter(([_, dataUser]) => dataUser.school === user.school && dataUser.class === user.class)));
            setSchoolUsers(oldUsers => Object.fromEntries(Object.entries(oldUsers).filter(([_, dataUser]) => dataUser.school === user.school)));
        }
    }, [user]);

    useEffect(() => {
        setLoading(user == null || users == null || schoolUsers == null || tests == null || interrogations == null || homeworks == null || others == null || timetable == null || subjects == null || announcements == null);
    }, [user, users, schoolUsers, tests, interrogations, homeworks, others, timetable, subjects, announcements]);

    if (showLatestUpdateNews && !window.location.href.includes("emailVerification")) 
        return <LatestUpdateNews setPage={ setPage } setShowLatestUpdateNews={ setShowLatestUpdateNews } user={ user } />;

    if (offline && !user)
        return <Offline />;

    if (!localStorage.getItem("appTourDone") && !window.location.href.includes("emailVerification"))
        return <AppTour />;

    if (window.location.href.includes("cookies"))
        return <Cookies />;

    if (navigator.userAgent.toLowerCase().includes("instagram"))
        return <main className="instagramBrowserWarning">
            <Lottie 
                style={{ backgroundColor: "rgb(44, 44, 44)" }}
                loop={ false }
                autoplay={ true }
                speed={ 0.1 }
                animationData={ warning_animation }
                height={ 300 }
                width={ 300 }
            />
            <h2>Esci da Instagram e apri l'app sul tuo browser per poterla scaricare e utilizzare</h2>
            <h4>Clicca sui tre puntini in alto a destra e poi su "Apri nel tuo browser"</h4>
        </main>

    return <AppContext.Provider value={{ 
        page, 
        setPage, 
        sectionsOrder, 
        setSectionsOrder,
        updateSectionOrder,
        deleteSectionOrder,
        showNavBar, 
        hideNavBar, 
        offline, 
        setOffline, 
        data, 
        setData, 
        user, 
        setUser, 
        users, 
        setUsers,
        schoolUsers,
        setSchoolUsers,
        tests,
        setTests,
        interrogations,
        setInterrogations,
        homeworks,
        setHomeworks,
        others,
        setOthers,
        timetable,
        setTimetable,
        subjects,
        setSubjects,
        deleteSubject,
        announcements,
        setAnnouncements,
        classPresidents,
        setClassPresidents,
        schoolPresidents,
        setSchoolPresidents,
        setNewEvents,
        setUpdatedEvents,
        editingSectionsOrder,
        setEditingSectionsOrder,
        flashCards, 
        setFlashCards, 
        deleteFlashCards, 
        updateFlashCards,
        registerAccessToken,
        setRegisterAccessToken,
        registerEvents,
        updateRegisterEvents,
        deleteRegisterEvent,
        registerStudentId, 
        setRegisterStudentId,
    }}>
        <main className="App">
            <Popup 
                show={ askCookieConsent  } 
                buttons={ <>
                    <Lottie                        
                        loop={ true }
                        autoplay={ true }
                        speed={ 0.1 }
                        animationData={ profile_animation  }
                        height={ 200 }
                        width={ 200 } />
                    <h4 style={{ textAlign: "center", color: "var(--orange)" }}>La tua privacy e i cookies</h4>                    
                    <h2 className="iOS-pwa-banner-h2">Abbiamo bisogno del tuo consenso per poter memorizzare sul tuo dispositivo dei dati per migliorare la tua esperienza con SchoolDiary. Puoi scegliere di non accettare i cookies di terze parti, ma le funzionalità dell'app potrebbero essere ridotte</h2>
                    <TextButton onClick={ () => window.location.href = "/cookies" } text="PIÙ OPZIONI" style={{ marginTop: "2rem", marginLeft: "2rem", marginRight: "2rem" }} />
                    <TextButton background="linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))" onClick={ () => {
                        localStorage.setItem("cookies", JSON.stringify({ preferenceCookies: true, statisticCookies: true, marketingCookies: true }));
                        setAskCookieConsent(false);
                    } } text="ACCETTA COOKIES" style={{ marginTop: ".5rem", marginLeft: "2rem", marginRight: "2rem" }} />
                    {/* <h5 style={{ textAlign: "center", marginTop: ".5rem", color: "#969393" }} onClick={ () => {
                        localStorage.setItem("cookieConsent", false);
                        setAskCookieConsent(false);
                    } }>Accetta solo i cookies essenziali</h5> */}
                </> } />
            <Popup 
                show={ !askCookieConsent && installationPrompt && checkIOS() && localStorage.getItem("appTourDone") && !window.location.href.includes("emailVerification") && !navigator.standalone && parseInt(localStorage.getItem("visited")) > 2 && parseInt(localStorage.getItem("visited")) < 100  } 
                buttons={ <>
                    <Lottie                        
                        loop={ true }
                        autoplay={ true }
                        speed={ 0.1 }
                        animationData={ profile_animation  }
                        height={ 200 }
                        width={ 200 } />
                    <h4 style={{ textAlign: "center", color: "var(--orange)" }}>Scarica SchoolDiary per un'esperienza migliore!</h4>                    
                    <h2 className="iOS-pwa-banner-h2">Premi sul tasto "Condividi" <img alt="" src={ icons.iOS_share_icon } className="iOS-pwa-banner-img"></img> e poi clicca su "Aggiungi a schermata Home"</h2>
                    <TextButton onClick={ () => setInstallationPrompt(false) } text="CHIUDI" style={{ marginTop: "2rem", marginLeft: "2rem", marginRight: "2rem" }} />
                    <TextButton onClick={ () => {
                        localStorage.setItem("visited", 100);
                        setInstallationPrompt(false);
                    } } text="NON MOSTRARE PIÙ" style={{ marginTop: ".5rem", marginLeft: "2rem", marginRight: "2rem" }} background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" />
                </> } />
            <Popup 
                show={ !askCookieConsent && installationPrompt && !checkIOS() && localStorage.getItem("appTourDone") && !window.location.href.includes("emailVerification") && !navigator.standalone && parseInt(localStorage.getItem("visited")) > 2 && parseInt(localStorage.getItem("visited")) < 100 } 
                buttons={ <>
                    <Lottie
                        style={{  height: "200px", width: "200px", display: "block", marginLeft: "auto", marginRight: "auto" }}
                        loop={ true }
                        autoplay={ true }
                        speed={ 0.1 }
                        animationData={ profile_animation  }
                        height={ 200 }
                        width={ 200 } />
                    <h4 style={{ textAlign: "center", color: "var(--orange)" }}>Scarica SchoolDiary per un'esperienza migliore!</h4>
                    <h2 className="iOS-pwa-banner-h2">Premi sui tre pallini in alto a destra <img alt="" src={ icons.more_icon } className="iOS-pwa-banner-img"></img> e poi clicca su "Installa"</h2>
                    <TextButton onClick={ () => setInstallationPrompt(false) } text="CHIUDI" style={{ marginTop: "2rem", marginLeft: "2rem", marginRight: "2rem" }} />
                    <TextButton onClick={ () => {
                        localStorage.setItem("visited", 100);
                        setInstallationPrompt(false);
                    } } text="NON MOSTRARE PIÙ" style={{ marginTop: ".5rem", marginLeft: "2rem", marginRight: "2rem" }} background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" />
                </> } />
            { (newEvents || updatedEvents) && <div className="classroomEvents">
                <img src={ icons.classroom_icon } className="classroomEventsIcon"></img>
                <h4 className="classroomEventsHeader">{ newEvents ? "Aggiunti eventi da Classroom" : updatedEvents && "Aggiornati eventi da Classroom" }</h4>
            </div> }
            {/* <Popup onClick={ () => setPremiumPopup({ show: false }) } show={ premiumPopup.show } text="Vinci il piano premium invitando almeno 3 amici su SchoolDiary! Dimenticati delle pubblicità in-app!" icon={ icons.premium_icon } buttons={ <> */}
            <Popup onClick={ () => setPremiumPopup({ show: false }) } show={ premiumPopup.show } text="Vinci il piano premium invitando almeno 3 amici su SchoolDiary" icon={ icons.premium_icon } buttons={ <>
                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} onClick={ e => {
                        e.stopPropagation();
                        navigator.share({ 
                            text: "Unisciti anche tu a SchoolDiary, il diario digitale condiviso con tutta la tua classe!",
                            url: `https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}&user=${user.id}`
                        });
                    } } icon={ icons.invite_orange_icon } background={ "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" } text={ "INVITA UN AMICO" } />
                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} onClick={ copyPremiumInviteLink } icon={ premiumInviteLinkCopied ? icons.check_icon : icons.copy_to_clipboard_icon } background={ premiumInviteLinkCopied && "linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))" } text={ premiumInviteLinkCopied ? "INVITO COPIATO" : "COPIA INVITO" } />         
                <IconButton style={{ paddingTop: ".5rem", paddingBottom: ".5rem", marginTop: "1rem" }} onClick={ () => setPage({ page: "menu", menuPage: "premium" }) } icon={ icons.question_mark_orange_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" text="SCOPRI DI PIU'" />         
            </>} />

            <BrowserRouter>
                <Switch>
                    <Route path="/offline" component={ Offline } />
                    <Route path="/links" component={ Links } />
                    <Route path="/auth" component={ FirebaseAuthHandler } />
                    <Route path="/discord" component={ Discord } />
                    <Route>
                        { () => {
                            switch (page.page) {
                                case "login":
                                    return <Login loginData={ page.loginData } />;
                                case "home":
                                    return <Home loading={ loading } showPremiumPopup={ () => setPremiumPopup({ show: true }) } />;
                                case "add":
                                    return <Add 
                                        id={ page.event?.id } 
                                        description={ page.event?.title } 
                                        type={ page.event?.type } 
                                        subject={ page.event?.subject } 
                                        date={ page.event?.date } 
                                        startDate={ page.event?.startDate } 
                                        endDate={ page.event?.endDate }
                                        replaceLesson={ page.event?.replaceLesson }
                                        duration={ page.event?.duration }
                                        for={ page.event?.for }
                                        grades={ page.event?.grades }
                                    />;
                                case "grades":
                                    return <Grades />;
                                case "menu":
                                    return <Menu page={ page.menuPage } timetableDay={ page.timetableDay } />;
                                case "study":
                                    return <Study />;
                                case "stripeHandler":
                                    return <StripeHandler setPage={ setPage } action={ page.action } status={ page.status } />
                                case "emailVerification":
                                    return <EmailVerification setPage={ setPage } />;
                                case "recoverPassword":
                                    return <RecoverPassword />;
                                case "announcement":
                                    return <Announcement id={ page.announcementId } />;
                                case "schoolAnnouncement":
                                    return <Announcement school={ true } id={ page.announcementId } />;
                                default:
                                    return null;
                            }
                        } }
                    </Route>
                </Switch>
            </BrowserRouter>
            { (!NO_NAV_PAGES.includes(window.location.pathname) && !NO_NAV_PAGES.includes(page.page) && !loading) && <nav className="nav" ref={ nav }>
                <svg width="24px" height="24px" viewBox="0 0 21 18" onClick={ () => setPage({ page: "home" }) }>
                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                            <g id="Social" transform="translate(100.000000, 4044.000000)">
                                <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                    <g>
                                        <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                        <path style={{ transition: "all .5s ease" }} d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill={ (page.page === "home" || page.page === "grades") ? "#FF8C00" : "white" }></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ transform: "scale(1.2)", transition: "all .5s ease" , fill: (page.page === "add" || page.page === "announcement" || page.page === "schoolAnnouncement") ? "#d86c07" : "white" }} onClick={ () => setPage({ page: "add" }) }>
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
                {/* <svg height="24px" viewBox="6 4 40 40" width="24px" style={{ transition: "all .5s ease" }} fill={ page.page === "study" ? "#d86c07" : "#fff" } onClick={ () => setPage({ page: "study" }) }>
                    <path d="M16.05 40q-1.2 0-2.1-.9-.9-.9-.9-2.1v-5h6.2v-6.35q-1.9.15-3.8-.525T12.05 23v-2.9h-2.5L3 13.55q1.8-1.7 4.3-2.775T12.4 9.7q1.5 0 3.425.475 1.925.475 3.425 1.525V8H42v26.75q0 2.2-1.525 3.725T36.75 40Zm6.2-8H34.5v2.75q0 1 .625 1.625T36.75 37q1 0 1.625-.625T39 34.75V11H22.25v2.85L34.3 25.9v2.15h-2.15l-6.3-6.3-.85 1q-.65.75-1.3 1.15-.65.4-1.45.75ZM10.9 17.1h4.15v4.45q.85.55 1.675.825.825.275 1.675.275 1.25 0 2.55-.675 1.3-.675 1.9-1.375l.85-1-3.45-3.45q-1.6-1.6-3.6-2.525-2-.925-4.25-.925-1.35 0-2.45.325T7.7 13.9ZM31.5 35H16.05v2H32.2q-.3-.3-.5-.825-.2-.525-.2-1.175Zm-15.45 2v-2 2Z"/>
                </svg> */}
                <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ transition: "all .5s ease" }} fill={ page.page === "menu" ? "#d86c07" : "#fff" } onClick={ () => setPage({ page: "menu" }) }>
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                </svg>
            </nav> }
        </main>
    </AppContext.Provider>
    

}

export default App;
